export default __webpack_public_path__ + "locales/sk/ArchiveDialog.json?hash=fce6e6938b20b9a01497d4228737782e";